import { CATEGORIES } from '../../utils/constants';

const { PERFORMANCE, TOPIC_IN_FOCUS, TAKE_ACTION, BACKGROUND } = CATEGORIES;

export const PAGES_CATEGORIES = {
  'what-is-pefa': BACKGROUND,
  'methodology': BACKGROUND,
  'global-pfm-performance': PERFORMANCE,
  'crisis-budgeting': TOPIC_IN_FOCUS,
  'case-studies': TOPIC_IN_FOCUS,
  'a-call-to-action': TAKE_ACTION,
  'a-call-to-researchers': TAKE_ACTION,
  'gender-responsiveness': BACKGROUND,
};
